import { getLogout } from '@api/authentication'
import { useGlobalLoading } from '@hooks/useGlobalLoading'
import { usePubDispatch } from '@redux/hook'
import { reset as resetAuth } from '@redux/slices/authSlice'
import { reset as resetWaterAccount } from '@redux/slices/waterAccountSlice'
import { ROUTE_PATHS } from '@routes/index'
import { Helpers } from '@utils/helper'
import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export interface ILoginPayload {
  last4Nric: string
  otp: string
  emailOrPhoneNumber: string
}

export const useLogout = () => {
  const [isCalling, setIsCalling] = useState<boolean>(false)
  const dispatch = usePubDispatch()
  const navigate = useNavigate()
  const loading = useGlobalLoading()

  const clearData = useCallback(() => {
    Helpers.clearCachedData()
    dispatch(resetAuth())
    dispatch(resetWaterAccount())
  }, [dispatch])

  const logout = useCallback(async () => {
    const loadingId = loading.present({ title: 'Logging out' })
    try {
      setIsCalling(true)
      await getLogout()
      setIsCalling(false)
      clearData()
      navigate(ROUTE_PATHS.LOGIN)
    } catch (error) {
      setIsCalling(false)
      clearData()
      navigate(ROUTE_PATHS.LOGIN)
    } finally {
      loading.dismiss(loadingId)
    }
  }, [clearData, navigate, loading])

  return { isCalling, logout }
}
